import { adaptBoolean, adaptHtml, adaptMedia, adaptSelector } from 'adapters/base';

export const adaptMediaComponent = (component, language) => {
  try {
    const imageVideo = adaptMedia(component.contentFields[0], 'image_video', language);
    const imageVideoMobile = adaptMedia(component.contentFields[0], 'image_video_mobile', language);
    const image4K = adaptMedia(component.contentFields[0], 'image_4k', language);

    return {
      id: component.path,
      type: 'media',
      controlId: component.controlId,
      fields: {
        imageVideo: imageVideo,
        imageVideoMobile: imageVideoMobile,
        image4K: image4K,
        typeMedia: { staticValue: imageVideo.staticValue.type },
        backgroundColor: adaptHtml(component.contentFields[0], 'background_color', language, 'transparent'),
        fullWidth: adaptBoolean(component.contentFields[0], 'full_width', language, false),
        videoMode: adaptSelector(component.contentFields[0], 'video_mode', language, 'autoplay_muted'),
        videoUrl: adaptHtml(component.contentFields[0], 'video_url', language),
        marginBottom: adaptSelector(component.contentFields[0], 'margin_bottom', language, 'margin__bottom__160'),
        logo: adaptMedia(component.contentFields[0], 'logo', language),
        size: adaptSelector(component.contentFields[0], 'size', language, 'default'),
        hideVideoControls: adaptBoolean(component.contentFields[0], 'hide_video_controls', language, false),
        showImageFullHeight: adaptBoolean(component.contentFields[0], 'show_image_full_height', language, false),
        scaleAnimation: adaptBoolean(component.contentFields[0], 'scale_animation', language, false),
      },
    };
  } catch (e) {
    console.error('Error adapting Media component', e);
    return null;
  }
};
